import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export interface AuthSubmitButtonProps {
	children: ReactNode
	isLoading?: boolean
	disabled?: boolean
}

export function AuthSubmitButton({ children, isLoading = false, disabled = false }: AuthSubmitButtonProps) {
	const { t } = useTranslation('common')
	return (
		<button
			type="submit"
			disabled={isLoading || disabled}
			className={`
				w-full py-3 px-4 rounded-full font-medium text-white text-base
				bg-gradient-to-r from-[#225DFC] to-[#9726FA]
				hover:brightness-130
				focus:outline-none focus:ring-2 focus:ring-[#6366F1]/50 focus:ring-offset-2
				shadow-lg shadow-[#225DFC]/30
				hover:shadow-xl
				translate-y-0
				hover:translate-y-[-1px]
				relative
				transition-all duration-400
				disabled:opacity-70 disabled:cursor-not-allowed
				flex items-center justify-center gap-2
				cursor-pointer
				z-50
			`}
		>
			{isLoading
				? (
					<>
						<LoadingSpinner />
						<span>{t('auth.pleaseWait')}</span>
					</>
				)
				: children}
		</button>
	)
}

function LoadingSpinner() {
	return (
		<svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
			<circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
			<path
				className="opacity-75"
				fill="currentColor"
				d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
			/>
		</svg>
	)
}
